<template>
    <b-card no-body>
        <b-card-header>
            <span class="h5">
                USUÁRIO -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </span>
        </b-card-header>
        <b-card-body>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <div>
                <b-row>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label for="email">Login</label>
                            <b-form-input
                                type="text"
                                id="login"
                                v-model="usuarioDto.login"
                                placeholder="Insira o Login "
                                :disabled="false"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="5">
                        <b-form-group>
                            <label for="nome">Nome</label>
                            <b-form-input
                                type="text"
                                id="nome"
                                v-model="usuarioDto.nome"
                                placeholder="Insira o nome "
                                :disabled="false"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="4">
                        <b-form-group>
                            <label for="email">E-mail</label>
                            <b-form-input
                                type="text"
                                id="email"
                                v-model="usuarioDto.email"
                                placeholder="Insira o e-mail "
                                :disabled="false"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
        </b-card-body>
        <b-card-footer>
            <b-button
                variant="primary"
                @click.stop="salvarForm()"
                :disabled="!habilitarSalvar"
                class="mr-2"
            >
                <i class="fa fa-save"></i> Salvar
            </b-button>
            <b-button variant="danger" @click.stop="cancelar()" class="mr-2">
                <span> <i class="fa fa-remove"></i> Cancelar </span>
            </b-button>
        </b-card-footer>
    </b-card>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import UsuariosServicos from './UsuariosServicos'

export default {
    data() {
        return {
            erros: [],
            usuarioDto: {
                nome: '',
                email: '',
                login: '',
                usuarioId: '',
            },
        }
    },

    created() {
        if (this.$route.params.usuarioId != null) {
            this.obterUsuario()
        }
    },

    methods: {
        obterUsuario() {
            this.$store.dispatch('addRequest')
            UsuariosServicos.obterPorId(this.$route.params.usuarioId).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.preencheFormulario(response.data)
                            
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        salvarForm() {
            let usuario = {
                nome: this.usuarioDto.nome.toUpperCase(),
                email: this.usuarioDto.email.toLowerCase(),
                login: this.usuarioDto.login.toLowerCase(),
            }
            if (this.operacao == 'ATUALIZAR') {
                usuario.usuarioId = this.usuarioDto.usuarioId
            } 
            this.salvarUsuario(usuario)
        },

        cancelar() {
            this.erros = []
            this.$router.push({ name: 'Usuarios' })
        },

        salvarUsuario(usuario) {
            this.$store.dispatch('addRequest')
            let promisse
            if (this.operacao == 'INSERIR') {
                promisse = UsuariosServicos.inserirUsuario(usuario)
            } else {
                promisse = UsuariosServicos.atualizarUsuario(usuario)
            }
            promisse.then(response => {
                if (response) {
                    if (response.success) {
                        let usuarioId
                        if (this.operacao == 'INSERIR') {
                            usuarioId = response.data
                        } else {
                            usuarioId = usuario.usuarioId
                        }
                        this.registroSalvoComSucesso(usuarioId)
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso(usuarioId) {
            this.erros = []
            this.$toast.success(
                'Registro salvo com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$store.dispatch('setRecarregar', true)
            this.$router.push({
                name: 'Usuarios_Detalhar',
                params: { usuarioId: usuarioId }
            })
        },

        preencheFormulario(data) {
            if (data) {
                this.usuarioDto.nome = data.nome.toUpperCase()
                this.usuarioDto.email = data.email
                this.usuarioDto.login = data.login
                this.usuarioDto.usuarioId = data.usuarioId
            }
        },

        limparFormulario() {
            this.usuarioDto.nome = ''
            this.usuarioDto.email = ''
            this.usuarioDto.login = ''
        }
    },

    computed: {
        habilitarSalvar() {
            return !this.$v.$invalid
        },

        operacao() {
            if (this.$route.name == 'Usuarios_Inserir') {
                return 'INSERIR'
            } else {
                return 'ATUALIZAR'
            }
        }
    },

    validations: {
        usuarioDto: {
            nome: {
                required
            },
            email: {
                required,
                email
            },
            login: {
                required
            }
        }
    }
}
</script>
